import React from 'react';

export const PromiseSection: React.FC = () => {
  const promises = [
    {
      icon: 'ri-user-search-line',
      title: '精選符合僱主要求的經驗、技能及語言能力的外勞',
      description: '嚴格篩選，確保每位外勞都符合您的具體需求'
    },
    {
      icon: 'ri-file-list-3-line',
      title: '提供外勞配額申請全方位服務',
      description: '專業團隊協助處理所有申請文件和程序'
    },
    {
      icon: 'ri-handshake-line',
      title: '與內地官方指定勞務機構合作，確保可靠人選',
      description: '與14間官方勞務公司緊密合作，保證合法透明'
    },
    {
      icon: 'ri-home-4-line',
      title: '專業宿舍管理方案，涵蓋衛生、舒適及法律合規',
      description: '提供完整住宿解決方案，確保合規舒適'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-green-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            我們的承諾
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            專業人力資源，助您無憂招聘
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {promises.map((promise, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className={`${promise.icon} text-green-600 text-xl`}></i>
                </div>
                <div>
                  <div className="flex items-center mb-3">
                    <i className="ri-checkbox-circle-fill text-green-500 text-xl mr-2"></i>
                    <h3 className="text-lg font-semibold text-gray-900">
                      {promise.title}
                    </h3>
                  </div>
                  <p className="text-gray-600">
                    {promise.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-green-600 to-blue-600 text-white p-8 rounded-xl">
            <h3 className="text-2xl font-bold mb-4">萬業人才資本，您的信賴之選！</h3>
            <p className="text-lg mb-6">立即聯繫我們，體驗高效、專業的外勞招聘服務！</p>
            <div className="flex justify-center">
              <button 
                onClick={() => window.open('https://wa.me/85295515256', '_blank')}
                className="bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-700 transition-colors duration-300 flex items-center whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line mr-2"></i>
                立即WhatsApp聯繫
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
